module.exports = __webpack_public_path__ + "img/moneyConfirmed.2ef854f5.svg";